let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("36ci0")).then(() => parcelRequire('ljBzG'));